import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrlWithQuery, buildAuthHeadersForFetch } from "./RestService";
import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IVendorModel from "../models/IVendorModel";
import ICategory from "../models/ICategory";

/**
 * Options for fetching categories
 */
export interface IGetCategoriesOptions {
    catalogGuid?: string;
    onlyRootCategories?: boolean;
    isVendorCategory?: boolean;
    isOrderCategory?: boolean;
    isTakeOffCategory?: boolean;
    isHomeCategories?: boolean;
    noIncludes?: boolean;
}

interface CategoriesApiResponse {
    categories: ICategory[];
}

/**
 * Fetch categories via REST API
 */
const getCategories = async (
    options: IGetCategoriesOptions,
    userModel: IUserUI,
    supplierModel: ISupplierModel,
    vendorModel?: IVendorModel
): Promise<ICategory[]> => {
    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.CategoriesGet,
        query: options,
    });

    const headers = buildAuthHeadersForFetch({
        userModel,
        supplierModel,
        vendorModel,
    });

    const response = await fetch(url, {
        method: "GET",
        headers,
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch categories: ${response.statusText}`);
    }

    const data: CategoriesApiResponse = await response.json();
    return data.categories;
};

const CategoryService = {
    getCategories,
};

export default CategoryService;
